import { Component, OnInit } from '@angular/core';
import { PagesContentService } from '../../services/pages-content.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-page-editor',
  templateUrl: './page-editor.component.html',
  styleUrls: ['./page-editor.component.scss']
})
export class PageEditorComponent implements OnInit {
  // List of components you can edit.
  availableComponents: string[] = [
    'family', 'allmyhugs', 'norametrics', 'newsresponders', 'monestary',
    'education', 'travel', 'communitydev', 'remotecareerboard', 'bizbasebegin',
    'lifebasebegin', 'antisocialmedia', 'HowdjyaDoit', 'lobbyhobbies', 'hopesanddreams'
  ];
  selectedComponent: string = '';
  content: string = '';
  message: string = '';
  safeContent: SafeHtml = '';

  constructor(
    private pagesContentService: PagesContentService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // Optionally, auto-select a default component
    if (this.availableComponents.length > 0) {
      this.selectedComponent = this.availableComponents[0];
      this.loadContent();
    }
  }

  // Called when the selection changes
  onComponentChange(): void {
    this.loadContent();
  }

  // Load content for the selected component
  loadContent(): void {
    if (!this.selectedComponent) {
      return;
    }
    this.pagesContentService.getContent(this.selectedComponent).subscribe(res => {
      if (res.success && res.data) {
        this.content = res.data.content;
      } else {
        // If no content exists, start with empty content
        this.content = '';
      }
      this.message = '';
      this.updatePreview();
    });
  }

  // Save updated content for the selected component
  saveContent(): void {
    if (!this.selectedComponent) {
      return;
    }
    this.pagesContentService.saveContent(this.selectedComponent, this.content).subscribe(res => {
      this.message = res.message;
    });
  }

  // Update the live preview
  updatePreview(): void {
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
  }
}
